__turbopack_context__.v({
  "pageContent": "PageContent-module-scss-module__apyGsG__pageContent",
});
